




import { StorageService } from '@empathy/storage-service';
import { container, CoreComponent, DEPENDENCIES, EVENTS, STORAGE } from '@empathybroker/ebx-gluon';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    EmpathyX: CoreComponent
  }
})
export default class App extends Vue {
  mounted() {
    window.addEventListener<'popstate'>(
        'popstate',
        this.closeEmpathyXIfNoQuery
    );
    // TODO Leave this here for a while to ensure that the previous user information is removed. Probably summer 2022 is enough.
    this.removeOldUserInfo();
  }

  beforeDestroy() {
    window.removeEventListener<'popstate'>(
        'popstate',
        this.closeEmpathyXIfNoQuery
    );
  }

  private closeEmpathyXIfNoQuery(historyEvent: PopStateEvent) {
    const hrefHistoryState = historyEvent.state.href;
    if (hrefHistoryState) {
      const hasQuery = new URL(hrefHistoryState).searchParams.has('q');
      if (!hasQuery) {
        this.$x.emit(EVENTS.CloseEmpathyX);
      }
    }
  }

  private removeOldUserInfo(): void {
    const storage = container.getNamed<StorageService>(DEPENDENCIES.StorageService, STORAGE.Local);
    storage.removeItem('user-id');
    storage.removeItem('user-type');
  }
}
